module.exports = __webpack_public_path__ + "img/fb-icon.296a7c67.svg";